import React, { useState } from 'react';
import moment from 'moment';
import {
  ModalOverlay,
  ModalContainer,
  CloseButton,
  BackButton,
  CalendarIcon,
  ModalTitle,
  ModalDescription,
  VisitInfoCard,
  ConsultantSection,
  DateSection,
  SummarySection,
  SummaryTitle,
  SummaryText,
  ActionPlansSection,
  ConsultantPlan,
  ResellerPlan,
  PlanTitle,
  AttentionTitle,
  PlanText,
  ButtonContainer,
  ActionButton,
  CancelButton,
  SkeletonContainer,
  SkeletonHeader,
  SkeletonHeaderTitle,
  SkeletonHeaderBadge,
  SkeletonLineLarge,
  SkeletonLine,
  SkeletonLineShort,
  SkeletonButtons,
  SkeletonButton,
  LegalText,
  ToggleButton
} from './styles';
import CalendarModalIcon from '../../assets/images/calendar.svg';
import ArrowIcon from '../../assets/images/arrow.svg';
import { toast } from 'react-toastify';
import { getAppointmentDetailsById } from '../../services/commitmentService';

const VisitValidationModal = ({
  isOpen,
  onClose,
  onBack,
  consultantName,
  visitDate,
  visitTime,
  onImmediateConfirm,
  onImmediateDeny,
  appointmentId: appointmentIdProp,
  showFeedbackModal = false,
  setShowFeedbackModal = () => {},
  setFeedbackType = () => {},
  showConsultantRatingModal = false,
}) => {
  const [appointment, setAppointment] = useState(null);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    summary: false,
    consultorPlan: false,
    resellerPlan: false,
  });

  const charLimit = 300;

  const toggleSection = (sectionName) => {
    setExpandedSections(prev => ({
      ...prev,
      [sectionName]: !prev[sectionName]
    }));
  };

  const shouldShowToggle = (text) => text && text.length > charLimit;

  const renderTextWithToggle = (text, sectionName) => {
    if (!text) return text;
    const isExpanded = expandedSections[sectionName];
    const shouldShow = shouldShowToggle(text);

    return (
      <div>
        <div>
          {isExpanded ? text : shouldShow ? `${text.substring(0, charLimit)}...` : text}
        </div>
        {shouldShow && (
          <ToggleButton onClick={() => toggleSection(sectionName)}>
            {isExpanded ? 'Ver menos' : 'Ver mais'}
          </ToggleButton>
        )}
      </div>
    );
  };


  React.useEffect(() => {
    const fetchDetails = async () => {
      setLoadingDetails(true);
      try {
        const id = appointmentIdProp;
        const res = await getAppointmentDetailsById(id);
        const data = (res && res.data) ? res.data : res;
        setAppointment(data);
      } catch (err) {
        console.warn('Erro ao buscar detalhes da visita', err);
        try { toast.error('Ocorreu um erro ao carregar os detalhes da visita'); } catch (e) {}
        try { onClose && onClose(); } catch (e) {}
      }
      setLoadingDetails(false);
    };

    if (isOpen) fetchDetails();
  }, [isOpen]);

  if (!isOpen) return null;

  let formattedDate = visitDate;

  try {
    const sourceDate = appointment && appointment.StartDateTime ? appointment.StartDateTime : visitDate;
    const mDate = moment(sourceDate, moment.ISO_8601, true);
    if (mDate.isValid()) {
      formattedDate = mDate.format('DD/MM/YYYY');
      formattedTime = mDate.format('HH:mm');
    } else {
      const mTime = moment(visitTime, moment.ISO_8601, true);
      if (mTime.isValid()) {
        formattedTime = mTime.format('HH:mm');
      }
    }
  } catch (e) {
    console.log('error => ', e);
  }


  if (isOpen && loadingDetails) {
    return (
      <ModalOverlay onClick={onClose}>
        <ModalContainer onClick={(e) => e.stopPropagation()}>
          <SkeletonContainer>
            <SkeletonHeader>
              <SkeletonHeaderTitle />
              <SkeletonHeaderBadge />
            </SkeletonHeader>
            <SkeletonLineLarge />
            <SkeletonLine />
            <SkeletonLine />
            <SkeletonLineShort />
            <SkeletonButtons>
              <SkeletonButton />
              <SkeletonButton />
            </SkeletonButtons>
          </SkeletonContainer>
        </ModalContainer>
      </ModalOverlay>
    );
  }

  const handleConfirm = () => {
    setFeedbackType('agreement');
    if (typeof onImmediateConfirm === 'function') {
      try {
        onImmediateConfirm();
      } catch (e) {
        console.warn('VisitValidationModal onImmediateConfirm error', e);
      }
    }
    setShowFeedbackModal(true);
  };

  const handleDeny = () => {
    setFeedbackType('disagreement');
    if (typeof onImmediateDeny === 'function') {
      try {
        onImmediateDeny();
      } catch (e) {
        console.warn('VisitValidationModal onImmediateDeny error', e);
      }
    }
    setShowFeedbackModal(true);
  };

  return (
    <>
      {!showFeedbackModal && !showConsultantRatingModal && (
        <ModalOverlay>
          <ModalContainer onClick={(e) => e.stopPropagation()}>

          <BackButton onClick={(e) => { e.stopPropagation(); if (typeof onBack === 'function') onBack(); }}>
            <img src={ArrowIcon} alt="Voltar" />
            <span>Voltar</span>
          </BackButton>

            <CloseButton onClick={onClose}>
              ✕
            </CloseButton>

            <CalendarIcon>
              <img src={CalendarModalIcon} alt="Calendário" />
            </CalendarIcon>

            <ModalTitle>Validação da visita</ModalTitle>
            <ModalDescription>
              Confira abaixo as informações discutidas na visita.<br />
              Está de acordo com o que foi conversado?
            </ModalDescription>

            <VisitInfoCard>
              <ConsultantSection>
                <span>👤</span>
                <div>
                  <span>Nome do consultor</span>
                  <strong>{consultantName}</strong>
                </div>
              </ConsultantSection>

              <DateSection>
                <span>📅</span>
                <div>
                  <span>Data da visita</span>
                  <strong>{formattedDate}</strong>
                </div>
              </DateSection>
            </VisitInfoCard>

            <SummarySection>
              <SummaryTitle>Resumo da visita</SummaryTitle>
              <SummaryText>
                {renderTextWithToggle(
                  appointment && appointment.Description ? appointment.Description : '',
                  'summary'
                )}
              </SummaryText>
            </SummarySection>

            <ActionPlansSection>
              <SummaryTitle>Planos de ação</SummaryTitle>

              <ConsultantPlan>
                <PlanTitle>Consultor</PlanTitle>
                <PlanText>
                  {renderTextWithToggle(
                    appointment && appointment.PlanosDeAcaoConsultor ? appointment.PlanosDeAcaoConsultor : 'Plano de ação do consultor não disponível.',
                    'consultorPlan'
                  )}
                </PlanText>
              </ConsultantPlan>

              <ResellerPlan>
                <PlanTitle>Revendedor</PlanTitle>
                <PlanText>
                  {renderTextWithToggle(
                    appointment && appointment.PlanosDeAcaoRevendedor ? appointment.PlanosDeAcaoRevendedor : 'Plano de ação do revendedor não disponível.',
                    'resellerPlan'
                  )}
                </PlanText>
              </ResellerPlan>
            </ActionPlansSection>
            <AttentionTitle>ATENÇÃO 🚨</AttentionTitle>
            <LegalText>
              <b>RESSALVA LEGAL: </b>
                 Os eventuais compromissos assumidos pela Ultragaz
                 nesta mensagem consideram exclusivamente o contexto atual da negociação
                 e da relação contratual entre a Ultragaz e V. Senhoria, estando
                 condicionados ao cumprimento integral de todas as obrigações assumidas por
                 V. Senhoria, seja de natureza contratual ou decorrente de outro meio.
              <br /><br />
              <b>AVISO DE CONFIDENCIALIDADE: </b>
                Esta mensagem, incluindo seus anexos, contém informações confidenciais
                destinadas exclusivamente ao responsável pelo estabelecimento comercial
                destinatário e somente poderá ser utilizada no âmbito da relação comercial
                existente entre a Ultragaz e V. Senhoria. É expressamente proibido o uso, acesso,
                reprodução ou divulgação não autorizada do conteúdo desta mensagem, sob pena de
                infração contratual. Caso você não seja o destinatário, fica desde já notificado de
                que não poderá utilizar, copiar ou divulgar as informações aqui contidas, devendo
                delatar a mensagem imediatamente, sob pena de responder no âmbito cível e criminal.
            </LegalText>
            <ButtonContainer>
              <CancelButton onClick={handleDeny}>
                Não estou de acordo
              </CancelButton>
              <ActionButton onClick={handleConfirm}>
                Sim, está correto
              </ActionButton>
            </ButtonContainer>
          </ModalContainer>
        </ModalOverlay>
      )}
    </>
  );
};

export default VisitValidationModal;
